import { Component, OnInit } from '@angular/core';
import { Company } from '../../../../models/company';
import { CompanyService } from '../../../../services/company.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Audit_Log } from '../../../../models/audit_log';
import { AuthService } from '../../../../services/auth.service';
import { PDAUser } from '../../../../models/pda_User';
import { PDAUserType } from '../../../../models/pda_User_Type';
import { PDAUserService } from '../../../../services/pda-user.service';

@Component({
  selector: 'app-pda-user-manage',
  templateUrl: './pda-user-manage.component.html',
  styleUrls: ['./pda-user-manage.component.css']
})
export class PDAUserManageComponent implements OnInit {
  companies: Company[];
  pdaUser: PDAUser;
  pdaUserTypes: PDAUserType[];
  client;
  isLockoutResetNeeded: Boolean = false;

  constructor(private companyService: CompanyService, authService: AuthService, private pdaUserService: PDAUserService,
    private router: Router, private route: ActivatedRoute) {
    this.client = authService.currentUser.value;
    this.pdaUser = new PDAUser();
    
    console.log(this.pdaUser);
  }

  ngOnInit() {
    this.companyService.getAll(0).then((companyData) => {
      this.companies = companyData;
      this.pdaUserService.getAllUserTypes().then((userTypeData) => {
        this.pdaUserTypes = userTypeData;
        console.log(this.pdaUserTypes);

        this.route.queryParams.subscribe(params => {
          const user_Id = params['user_Id'];

          if (user_Id != undefined) {

            this.pdaUserService.get(user_Id).then((data) => {
              this.pdaUser = data;

              this.pdaUser.confirm_Android_Pin = this.pdaUser.android_Pin;
              this.pdaUser.pda_User_Id = data.pdA_User_Id; //I Don't know why its make the A capitalised'
              this.pdaUser.pda_User_Type_Id = data.pdA_User_Type_Id;
              this.pdaUser.pda_User_Type_Name = data.pdA_User_Type_name;
              this.pdaUser.rfid_Enabled = data.rfiD_Enabled;
              if (this.pdaUser.locked_Out === true) {
                this.isLockoutResetNeeded = true;
              }
              console.log("Data");
              console.log(this.pdaUser);
              this.pdaUser.is_edit = true;
            });
          }
        });

      });
    });
  }

  submit() {
    this.adjustLoginAttempts();
  
    this.pdaUserService.save(this.pdaUser).then((data) => {
      if (data.success === true) {
        this.router.navigate(['users/tablet_management']);
      } else {
        console.error('Save failed:', data);
      }
    }).catch((error) => {
      console.error('An error occurred while saving:', error);
    });
  }
  
  private adjustLoginAttempts() {
    if (this.isLockoutResetNeeded && !this.pdaUser.locked_Out) {
      this.pdaUser.login_Attempts = 0;
    } else if (!this.isLockoutResetNeeded && this.pdaUser.locked_Out) {
      this.pdaUser.login_Attempts = 3;
    }
  }


}
